//scripts for smarty html theme
//window.plugin_path = "/content/theme/plugins/";
//window.isLoaded = false;
//window.isMapLoaded = false;
//window.wc = {};
//window.wc.apiKey = "123FD7F0-FF6C-4A9D-80FB-05C694C9ED03";//, //cbs - Grand Limousine Test
//window.apiKey = "123FD7F0-FF6C-4A9D-80FB-05C694C9ED03";//, //cbs - Grand Limousine Test
//    //stripeId: 'pk_live_T1zG3FK86lrCmjucq4ppwoT3', //cbs - Grand Limousine Live
//window.wc.stripeI = 'pk_test_ON7nWVZSOENc8TUmS25qopSD';//, //cbs - Grand Limousine Live
//window.wc.baseApiUrl = 'http://test-account.chauffeurbookingsoftware.com';
//};

import Vue from 'vue'
import App from './vue/bookingApp.vue'
import TopBookingForm from './vue/bookingForm/topBookingFormComponent.vue'
import ContactForm from './vue/bookingForm/contactForm.vue'
import CustomerContactForm from './vue/forms/customerContactForm.vue'
import CustomerContactFormModal from './vue/forms/customerContactFormModal.vue'
import TermsAndCondModal from './vue/forms/termsAndCondModal.vue'
import { BookingStore } from "./vue/vuexStores/index.js";

import '../../../node_modules/pickadate/lib/compressed/themes/classic.css'
import '../../../node_modules/pickadate/lib/compressed/themes/classic.date.css'
import '../../../node_modules/pickadate/lib/compressed/themes/classic.time.css'

//import "../../content/theme/css/essentials.css"
//import "../../content/theme/css/layout.css"
//import "../../content/theme/css/header-1.css"
//import "../../Content/theme/css/color_scheme/brown.css"
//import "../../Content/theme/css/custom.css"

//import "../../content/fontawesome/site.css"
//import "../../content/theme/css/vechicleList.css"


//import themeScripts from "../../content/theme/js/scripts.js";
//import extraScripts from "../../content/theme/js/extra.scripts.exec";
//import pageScripts from "../../content/theme/js/scripts.exec";




$(function () {
    var fullHeightSection = $(".fullheight-section");
    if (fullHeightSection.length > 0) {
        //if (fullHeightSection.height() > 600) {
        //    fullHeightSection.css({
        //        'height': (window.innerHeight - $('#header').height()) + 'px'
        //    });
        //}
    }

    window.isLoaded = true;
        initVue();
});

function initVue() {
    if (!window.isLoaded || !window.isMapLoaded) return;

    window.BookingStore = BookingStore;
    window.BookingStore.dispatch('updateConfiguration');

    if ($('#topBookingForm').length) {
        var bookingForm = new Vue({
            store: BookingStore,
            el: '#topBookingForm',
            render: h => h(TopBookingForm)
        });
    }

    if ($('#bookingApp').length) {
        var bookingApp = new Vue({
            store: BookingStore,
            el: '#bookingApp',
            beforeCreate() {
                console.log('before create element');
                this.$store.commit('initializeStore');
            },
            render: h => h(App)
        });
        window.bookingApp = bookingApp;
    }

    if ($('#contactFormModal').length) {
        var contactFormModal = new Vue({
            store: BookingStore,
            el: '#contactFormModal',
            render: h => h(ContactForm)
        });
        window.contactFromModal = contactFormModal;
    }

    if ($('#customerContactForm').length) {
        var customerContactForm = new Vue({
            store: BookingStore,
            el: '#customerContactForm',
            render: h => h(CustomerContactForm)
        });
    }

    if ($('#customerContactFormModal').length) {
        var customerContactFormModal = new Vue({
            store: BookingStore,
            el: '#customerContactFormModal',
            render: h => h(CustomerContactFormModal)
        });
    }

    if ($('#customerTermAndCondModal').length) {
        var customerTermAndCondModal = new Vue({
            store: BookingStore,
            el: '#customerTermAndCondModal',
            render: h => h(TermsAndCondModal)
        });
        //$('.showTermAndCondModal').on('click', function () { window.BookingStore.commit('setShowCustomerContactForm', true) });
        //$('.showTermAndCondModal').on('click', function () { window.BookingStore.commit('setShowTermsAndCondModal', true) });
    }

    $('.showContactFormButton').on('click', function () { window.BookingStore.commit('setShowCustomerContactForm', true) });
}

window._arr = {};
loadScript("//maps.googleapis.com/maps/api/js?key=" + window.websiteSettings.googleApiKey + "&libraries=places", function() {
    console.log('google maps loaded');
    window.isMapLoaded = true;
    initVue();
});

loadScript("https://js.stripe.com/v3/", function () { console.log('stripe loaded') });

window._arr = {};
function loadScript(scriptName, callback) {

    if (!_arr[scriptName]) {
        _arr[scriptName] = true;

        var body = document.getElementsByTagName('body')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptName;

        // then bind the event to the callback function
        // there are several events for cross browser compatibility
        // script.onreadystatechange = callback;
        script.onload = callback;

        // fire the loading
        body.appendChild(script);

    } else if (callback) {
        callback();
    }
};